import React, { useEffect, useState } from "react";
import MenuNav from "../composant/NavBarAdmin";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Criminal = () => {
  const navigate = useNavigate();
  const UrlBase = "https://ngs.adv.br/";
  const [menuConsulta, setMenuConsulta] = useState([]);

  // FORM
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [motivo, setMotivo] = useState("");
  const [mensagem, setMensagem] = useState("");

  const getMenuConsulta = async () => {
    try {
      const res = await fetch(UrlBase + "menu_consulta_ativo.php");
      const data = await res.json();
      setMenuConsulta(data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getMenuConsulta();
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    axios.post(UrlBase + "add_contato.php", {
      nome,
      email,
      telefone,
      motivo,
      mensagem,
    });
    alert("Mensagem enviada com sucesso.");
  };

  return (
    <>
    

      <main className="bg-slate-50 min-h-screen">

        {/* HERO */}
        <section className="bg-slate-900 text-white py-24">
          <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-14 items-center">

            {/* TEXTO */}
            <div>
              <h1 className="text-4xl md:text-5xl font-semibold leading-tight">
                Advocacia Criminal Estratégica
              </h1>

              <p className="mt-5 text-lg text-white/80 max-w-xl">
                Atuação imediata em flagrantes, audiências de custódia,
                investigações, processos criminais e recursos.
              </p>

              <a
                href="https://wa.me/message/IHVR2VYR6OHLJ1"
                className="inline-block mt-8 bg-emerald-600 hover:bg-emerald-700 px-8 py-4 rounded-2xl font-semibold text-white shadow-lg"
              >
                Falar agora no WhatsApp
              </a>

              <div className="mt-10 space-y-2 text-white/80">
                <p>✔ Atendimento imediato</p>
                <p>✔ Defesa técnica e estratégica</p>
                <p>✔ Comunicação clara e humana</p>
              </div>
            </div>

            {/* CARD CONSULTAS */}
            <div className="bg-white text-slate-900 rounded-3xl p-8 shadow-2xl">
              <h3 className="text-xl font-semibold mb-6">
                Consultas disponíveis
              </h3>

              <div className="space-y-4 max-h-96 overflow-y-auto pr-2">
                {menuConsulta.map((c) => (
                  <div
                    key={c.id}
                    className="flex justify-between items-start gap-4 border rounded-xl p-4 hover:bg-slate-50"
                  >
                    <span className="font-medium leading-snug">
{c.titre}</span>
                    <span className="font-semibold text-right min-w-[110px] text-slate-800">

                      R$ {c.tarif}
                    </span>
                  </div>
                ))}
              </div>

              <button
                onClick={() => navigate("/agendamento")}
                className="mt-8 w-full bg-slate-900 hover:bg-slate-800 text-white py-3 rounded-xl font-semibold"
              >
                Agendar consulta
              </button>
            </div>
          </div>
        </section>

        {/* DIFERENCIAIS */}
        <section className="py-20 bg-white">
          <div className="max-w-6xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-semibold">
              Como posso ajudar no seu caso
            </h2>

            <div className="grid md:grid-cols-3 gap-8 mt-12">
              {[
                {
                  title: "Atuação imediata",
                  desc: "Presença rápida em situações urgentes, especialmente em flagrantes."
                },
                {
                  title: "Defesa técnica",
                  desc: "Estratégia construída com base no processo, prova e jurisprudência."
                },
                {
                  title: "Acompanhamento humano",
                  desc: "Orientação clara ao cliente e familiares durante todo o processo."
                }
              ].map((item) => (
                <div
                  key={item.title}
                  className="bg-slate-50 p-8 rounded-3xl shadow-sm"
                >
                  <h3 className="text-xl font-semibold mb-3">
                    {item.title}
                  </h3>
                  <p className="text-slate-600">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CONTATO */}
        <section className="py-24 bg-slate-50">
          <div className="max-w-xl mx-auto px-6">
            <h2 className="text-3xl font-semibold mb-8 text-center">
              Entre em contato
            </h2>

            <form onSubmit={onSubmit} className="space-y-4 bg-white p-8 rounded-3xl shadow-lg">
              <input
                className="w-full border p-3 rounded-xl"
                placeholder="Nome completo"
                onChange={(e) => setNome(e.target.value)}
                required
              />
              <input
                className="w-full border p-3 rounded-xl"
                placeholder="E-mail"
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                className="w-full border p-3 rounded-xl"
                placeholder="Telefone"
                onChange={(e) => setTelefone(e.target.value)}
                required
              />
              <input
                className="w-full border p-3 rounded-xl"
                placeholder="Motivo do contato"
                onChange={(e) => setMotivo(e.target.value)}
                required
              />
              <textarea
                className="w-full border p-3 rounded-xl"
                placeholder="Mensagem"
                rows={4}
                onChange={(e) => setMensagem(e.target.value)}
                required
              />

              <button
                type="submit"
                className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-4 rounded-xl font-semibold"
              >
                Enviar mensagem
              </button>
            </form>
          </div>
        </section>

      </main>
    </>
  );
};

export default Criminal;
